// import $ from 'jquery';
window.$ = $;
import '../stylesheets/frontend';
require.context('../images');
require.context('../../assets/images');
require.context('../videos');
require.context('../files');
import '../shared/cloudinary';
import '../shared/common';
import Chartkick from "chartkick";
import "chartkick/chart.js";
// import "chartkick/highcharts"
import Highcharts from 'highcharts';

import 'cocoon';
import '../frontend/cocoon-discard';
import Cleave from 'cleave.js';
import 'select2';
import 'select2/dist/css/select2.css';
import 'trix/dist/trix.css';
import '../../assets/stylesheets/actiontext.scss';
import moment from 'moment';
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel';
import Inputmask from "inputmask";
import { showDragMap, showMap } from './shared/map';
import dragula from 'dragula';
import '../shared/firebase-base';
import RailsUjs from 'rails-ujs';
RailsUjs.start();

import { itineraryModels } from "../shared/itinerary_helper";
import { weatherWidget } from "../shared/weather_widget_helper";

//var sideBar = document.getElementById("mobile-nav");
//var toggler = document.getElementById("mobile-toggler");
//  sideBar.style.transform = "translateX(-260px)";
//let moved = true;
//function sidebarHandler() {
//  if (moved) {
//         sideBar.style.transform = "translateX(0px)";
//         moved = false;
//     } else {
//         sideBar.style.transform = "translateX(-260px)";
//         moved = true;
//     }
// }

function remove_option_except_first(element) {
  $(`${ element } option`).each(function() {
    if (this.value) {
      this.remove();
    }
  });
}
function select_country_and_fetch_states(element) {
  const itself = $(element);
  const form = itself.parents('form');
  const select_state_name = form.find('select.select_state_name:last');
  if (itself) {
    itself.change(() => {
      remove_option_except_first('.select_state_name');
      $.ajax({
        url: `/trips/fetch_states?country_name=${ itself.val() }`,
        success(data) {
          data.states.forEach(function(state, index) {
            select_state_name.append(new Option(state, state));
          });
        }
      });
      if (itself.hasClass('trip_edit_select_country_name')) {
        const edit_trip_step_display_img = form.find('img.edit_trip_step_display_img');
        const submit_button = form.find("button[type='submit']");
        submit_button.text('processing...');
        submit_button.attr('type', 'button');
        $.ajax({
          url: `/place_images/fetch_place_image?country_name=${ itself.val() }`,
          success(data) {
            edit_trip_step_display_img.attr('src', data.url);
            form.find('input.trip_photo_photo_url[type="hidden"]').val(data.url);
            setTimeout(function() {
              submit_button.text('Save Changes');
              submit_button.attr('type', 'submit');
            }, 500);
          }
        });
      }
    });
  }
}

function paste_data_to_show(get_element, show_element) {
  $(show_element).text($(get_element).val());
}

function _validate_trip_creation_step_(element) {
  let block_next = false;
  element.find('[required]').each(function() {
    let val = this.value;
    let anchor_value = !(val.length > 0);
    // if (this.value == "$0.00") {
    //   anchor_value = true;
    // }
    if (block_next && anchor_value == false) {
      return false;
    };
    block_next = anchor_value;
  });
  return block_next;
};

function validate_trip_creation_step(element) {
  let block_next = false;
  document.querySelector(element).querySelectorAll("[required]").forEach((anchor_element) => {
    let anchor_value = !anchor_element.value;
    if (block_next && anchor_value == false) {
      return false;
    };
    block_next = anchor_value;
  });
  return block_next;
}

function activate_contact_messages(element) {
  const element_parent = $(element).parents('div.my_message_contacts_children');
  const my_message_contact_parents = $(element).parents('div.my_message_contacts');
  my_message_contact_parents.find('div.my_message_contacts_children').each((key, event) => {
    if ($(event).find('a._new_contact_messages_message_').attr('href') == $(element).attr('href')) {
      $(event).addClass('bg-secondary');
      $(event).removeClass('bg-white');
      $(event).find('span.font-bold.div_user_name').addClass('text-white');
      $(event).find('span.text-sm.div_user_active_time').addClass('text-white');
    } else {
      $(event).removeClass('bg-secondary');
      $(event).addClass('bg-white');
      $(event).find('span.font-bold.div_user_name').removeClass('text-white');
      $(event).find('span.text-sm.div_user_active_time').removeClass('text-white');
      $(event).find('span.font-bold.div_user_name').addClass('body-text');
      $(event).find('span.text-sm.div_user_active_time').addClass('body-text');
    }
  });
}

function sort_element(a, b) {
  return parseInt($(b).data('index')) < parseInt($(a).data('index'));
}

function isEmail(email) {
  var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
}
const cleaveAssignment = () => {
  $('.input_ein').toArray().forEach((field) => {
    new Cleave(field, {
      blocks: [2, 7],
      delimiter: '-',
    });
  });

  $('.input_ssn').toArray().forEach((field) => {
    new Cleave(field, {
      blocks: [3, 2, 4],
      delimiter: '-',
    });
  });
};

const scroll_down_function = (_this_, element) => {
  if ($(_this_).scrollTop() + $(_this_).innerHeight() + 1 >= $(_this_)[0].scrollHeight) {
    let form = $(_this_).parents('form');
    if (form.find(element)) {
      form.find(element).attr('disabled', false);
    }
  }
};

let chart_colors = ['#7cb5ec', '#90ed7d', '#f7a35c', '#8085e9', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1', '#f15c80', '#434348'];

function maskCurrencyDecimalFields(element) {
  let elements;
  if (element && element.length > 0) {
    elements = element;
  } else {
    elements = document.querySelectorAll('input.currency_mask[type="text"]');
  }
  (new Inputmask("currency", {
    prefix: '$',
    rightAlign: false,
    // regex: "\\d*[\.]\\d{2}",

    // numericInput: true,
    placeholder: "0",
    definitions: {
      "0": {
        validator: "[0-9\uFF11-\uFF19]"
      }
    },
    onUnMask: function(maskedValue, unmaskedValue) {
      if (parseFloat(maskedValue.substring(1).replace(/,/g, ''), 10) >= 0) {
        return parseFloat(maskedValue.substring(1).replace(/,/g, ''), 10);
      }
    }
  })).mask(elements);
}

function maskPhoneNumberFields() {
  (new Inputmask("(999) 999-9999")).mask(document.querySelectorAll('input.phone_number_mask[type="tel"]'));
}

function maskPercentageFields() {
  (new Inputmask('percentage', {
    postfix: '%',
    rightAlign: false
  })).mask(document.querySelectorAll('#emergency_fund_percentage'));
}

function makeSocialSecurityFields() {
  (new Inputmask("999-99-9999")).mask(document.querySelectorAll('input.social_secuity_number_mask[type="password"]'));
}

function updateEmergencyFundPerMonth() {
  let available_monthly = document.getElementById('available_monthly').value;
  let percentage = Number(document.getElementById('emergency_fund_percentage').value.replace('%', ''));
  let money_per_month = available_monthly * percentage / 100.0;
  let goal_money = document.getElementById('goal_money').value;
  document.getElementById('money-per-month').innerHTML = moneyWithCurrency(money_per_month);
  let expected_months = goal_money / money_per_month;
  var options = { year: 'numeric', month: 'long', day: 'numeric' };
  const date = new Date();
  date.setMonth(date.getMonth() + expected_months);
  document.getElementById('expected-month').innerHTML = date.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' });
}

function moneyWithCurrency(money) {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });
  return formatter.format(money);
}

function updateAvailableMoneyBar(e) {
  var x = document.getElementById('available-money-part');
  if (window.getComputedStyle(x).display === 'none') {
    x.classList.remove("hidden");
    x.classList.add("visible");
    document.getElementById('recomendation-part').classList.remove('visible');
    document.getElementById('recomendation-part').classList.add('hidden');
  }
  var available_amount = Number(document.getElementById('emergency_fund_income').value.replace(/[^0-9.-]+/g, "")) - Number(e.target.value.replace(/[^0-9.-]+/g, ""));
  if (available_amount < 0) {
    document.getElementById('negative-money').innerHTML = '<span>You have a negative balance remaining after expenses.</span>';
  }
  else {
    document.getElementById('negative-money').innerHTML = `<span>You have </span><span id='#available-money'>${ moneyWithCurrency(available_amount) }</span><span> available to save after expenses</span>`;
  }


  document.getElementById('recomended-expense').innerHTML = moneyWithCurrency(Number(e.target.value.replace(/[^0-9.-]+/g, "")));
  document.getElementById('recomended-multiplication').innerHTML = moneyWithCurrency(Number(e.target.value.replace(/[^0-9.-]+/g, "") * 6));
}

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('#percentage-decreament').forEach(elem => {
    elem.addEventListener("click", e => {
      e.preventDefault();
      const target = document.getElementById('emergency_fund_percentage');
      let value = Number(target.value.replace('%', ''));
      value--;
      target.value = value;
      updateEmergencyFundPerMonth();
    });
  });

  document.querySelectorAll('#percentage-increament').forEach(elem => {
    elem.addEventListener("click", e => {
      e.preventDefault();
      const target = document.getElementById('emergency_fund_percentage');
      let value = Number(target.value.replace('%', ''));
      value++;
      target.value = value;
      updateEmergencyFundPerMonth();
    });
  });

  document.querySelectorAll('#emergency_fund_percentage').forEach(elem => {
    elem.addEventListener('input', updateEmergencyFundPerMonth);
  });

  document.querySelectorAll('#income_range').forEach(elem => {
    elem.addEventListener('input', e => {
      document.getElementById('emergency_fund_income').value = e.target.value;
    });
  });

  document.querySelectorAll('#emergency_fund_income').forEach(elem => {
    elem.addEventListener('input', e => {
      document.getElementById('income_range').value = Number(e.target.value.replace(/[^0-9.-]+/g, ""));
    });
  });

  document.querySelectorAll('#expenses_range').forEach(elem => {
    elem.addEventListener('input', e => {
      document.getElementById('emergency_fund_expenses').value = e.target.value;
      updateAvailableMoneyBar(e);
    });
  });

  document.querySelectorAll('#emergency_fund_expenses').forEach(elem => {
    elem.addEventListener('input', e => {
      document.getElementById('expenses_range').value = Number(e.target.value.replace(/[^0-9.-]+/g, ""));
      updateAvailableMoneyBar(e);
    });
  });

  document.querySelectorAll('#howmuch_range').forEach(elem => {
    elem.addEventListener('input', e => {
      document.getElementById('emergency_fund_howmuch').value = e.target.value;
      document.getElementById('recomendation-part').classList.remove('hidden');
      document.getElementById('recomendation-part').classList.add('visible');

      document.getElementById('available-money-part').classList.remove('visible');
      document.getElementById('available-money-part').classList.add('hidden');
    });
  });

  document.querySelectorAll('#emergency_fund_howmuch').forEach(elem => {
    elem.addEventListener('input', e => {
      document.getElementById('howmuch_range').value = Number(e.target.value.replace(/[^0-9.-]+/g, ""));
      document.getElementById('recomendation-part').classList.remove('hidden');
      document.getElementById('recomendation-part').classList.add('visible');

      document.getElementById('available-money-part').classList.remove('visible');
      document.getElementById('available-money-part').classList.add('hidden');
    });
  });

  var unsaved_changes = false;
  document.querySelectorAll('.add-new-important-date').forEach(elem => {
    elem.addEventListener('click', e => {
      unsaved_changes = true;
    });
  });

  document.querySelectorAll('.remove_fields.existing:not(.not_show_alert)').forEach(elem => {
    elem.addEventListener('click', e => {
      unsaved_changes = true;
    });
  });

  window.addEventListener("beforeunload", (event) => {
    if (unsaved_changes) {
      event.returnValue = "Changes you have made are not yet saved. Please click save to finalize, Cancel, Leave";
    }
  });


  $('.validate_input_greater_than_ten').change(function() {
    let submit = $(this).parents("form").find(":submit");
    if (parseFloat(this.value.substring(1).replace(/,/g, ''), 10) < 10) {
      submit.prop('disabled', true);
      submit.addClass('opacity-50');
      $(this).addClass("border-2");
      $(this).addClass("border-red-500");
      $(this).next().remove();
      $(this).parent().append(`
        <p class="text-red-500 text-xs italic">Amount must be greater or equal to $10</p>
        `);
    } else {
      submit.prop('disabled', false);
      submit.removeClass('opacity-50');
      $(this).removeClass("border-2");
      $(this).removeClass("border-red-500");
      $(this).next().remove();
    }
  });
  // let objDiv = ("div.update-container .reverse-scroll.mt-4 div");
  // objDiv.scrollTop = objDiv.scrollHeight;
  // $(objDiv).scrollTop($(objDiv)[0].scrollHeight);
  Inputmask.extendDefaults({
    removeMaskOnSubmit: true
  });
  dragula([document.querySelector('#dragula-container-payroll-file-format')], {
    isContainer: function(el) {
      return false; // only elements in drake.containers will be taken into account
    },
    moves: function(el, source, handle, sibling) {
      // return true; // elements are always draggable by default
      console.log($(handle));
      return handle.classList.contains('handle');
    },
    accepts: function(el, target, source, sibling) {
      let nested_fields_index = 1;
      $(target).find('tr.nested-fields').toArray().forEach((tr_element) => {
        $(tr_element).find('.hidden_column_order').val(nested_fields_index);
        nested_fields_index += 1;
      });
      return true; // elements can be dropped in any of the `containers` by default
    },
    invalid: function(el, handle) {
      return false; // don't prevent any drags from initiating by default
    },
    direction: 'vertical',             // Y axis is considered when determining where an element would be dropped
    copy: false,                       // elements are moved by default, not copied
    copySortSource: false,             // elements in copy-source containers can be reordered
    revertOnSpill: false,              // spilling will put the element back where it was dragged from, if this is true
    removeOnSpill: false,              // spilling will `.remove` the element, if this is true
    mirrorContainer: document.body,    // set the element that gets mirror elements appended
    ignoreInputTextSelection: true,     // allows users to select input text, see details below
    slideFactorX: 0,               // allows users to select the amount of movement on the X axis before it is considered a drag instead of a click
    slideFactorY: 0,               // allows users to select the amount of movement on the Y axis before it is considered a drag instead of a click
  });

  $(document).on('change', '[id^="payroll_method_"][id$="_company_no"], [id^="company_payroll_methods_attributes_"][id$="_company_no"]', function() {
    let form, company_no, select_earnings, select_deductions = "";
    if ($('[id^="payroll_method_"][id$="_company_no"]').length > 0) {
      form = $('[id^="payroll_method_"][id$="_company_no"]').parents('form');
      company_no = form.find('[id^="payroll_method_"][id$="_company_no"]').val();
      select_earnings = form.find('[id^="payroll_method_"][id$="_earning_code"]');
      select_deductions = form.find('[id^="payroll_method_"][id$="_deduction_code"]');
    } else {
      form = $('[id^="company_payroll_methods_attributes_"][id$="_company_no"]').parents('form');
      company_no = form.find('[id^="company_payroll_methods_attributes_"][id$="_company_no"]').val();
      select_earnings = form.find('[id^="company_payroll_methods_attributes_"][id$="_earning_code"]');
      select_deductions = form.find('[id^="company_payroll_methods_attributes_"][id$="_deduction_code"]');
    }
    select_earnings.children('option').remove();
    select_deductions.children('option').remove();
    const submit = form.find(':submit');
    if (company_no) {
      $.ajax({
        url: `/employer/payroll_methods/fetch_company_codes?company_no=${ company_no }`,
        success(data) {
          if (data.earnings) {
            data.earnings.forEach(function(earning, index) {
              select_earnings.append(new Option(`${ earning.code } - ${ earning.description }`, earning.code));
            });
          }
          if (data.deductions) {
            data.deductions.forEach(function(deduction, index) {
              select_deductions.append(new Option(`${ deduction.code } - ${ deduction.description }`, deduction.code));
            });
          }
          if (data.earning_response_status == "403" && data.deduction_response_status == "403") {
            alert("Invalid company code, please check");
          }
          if (data.deductions && data.earnings) {
            submit.removeClass("opacity-50");
            submit.attr("disabled", false);
          } else {
            if (submit.hasClass("opacity-50")) {
              submit.addClass("opacity-50");
            }
            if (!submit.attr("disabled")) {
              submit.attr("disabled", true);
            }
          }
        }
      });
    }
  });

  let participant_openSideBar = document.getElementById("participant-openSideBar");
  if (participant_openSideBar) {
    document.getElementById("participant-openSideBar").addEventListener("click", function(e) {
      let mobilenav = document.getElementById("participant-mobile-nav");
      mobilenav.classList.add('block');
      mobilenav.classList.remove('hidden');
    });
  }
  let participant_closeSideBar = document.getElementById("participant-closeSideBar");
  if (participant_closeSideBar) {
    document.getElementById("participant-closeSideBar").addEventListener("click", function(e) {
      let mobilenav = document.getElementById("participant-mobile-nav");
      mobilenav.classList.remove('block');
      mobilenav.classList.add('hidden');
    });
  }

  // $(document).on('change','input.validate_manager_employer_enrollment_registration_start_date[type="date"]',function(){
  //   let manager_employer_enrollment_email_eml = $(this).parents('form').find('.manager_employer_enrollment_email_eml');
  //   let submit_button = $(this).parents('form').find(':submit');
  //   if(this.value){
  //     manager_employer_enrollment_email_eml.attr('disabled',false);
  //     manager_employer_enrollment_email_eml.removeClass('opacity-50');
  //     submit_button.attr('disabled',true);
  //     submit_button.addClass('opacity-50');
  //   }else{
  //     manager_employer_enrollment_email_eml.attr('disabled',true);
  //     manager_employer_enrollment_email_eml.addClass('opacity-50');
  //     submit_button.attr('disabled',false);
  //     submit_button.removeClass('opacity-50');
  //   }
  // });

  $(document).on('click', 'button.manager_employer_enrollment_email_eml', function() {
    let form = $(this).parents('form');
    let submit_button = form.find("button:submit");
    let employer_name_field = form.find("input#employer_enrollment_employer_name");
    let contact_phone_field = form.find("input#employer_enrollment_contact_phone");
    let employee_headcount_field = form.find("select#employer_enrollment_employee_headcount");
    let payroll_provider_field = form.find("input#employer_enrollment_payroll_provider");
    let payroll_frequency_field = form.find("input#employer_enrollment_payroll_frequency");
    let street_field = form.find("input#employer_enrollment_address_attributes_street");
    let street2_field = form.find("input#employer_enrollment_address_attributes_street2");
    let city_field = form.find("input#employer_enrollment_address_attributes_city");
    let state_field = form.find("input#employer_enrollment_address_attributes_state");
    let zip_field = form.find("input#employer_enrollment_address_attributes_zip");
    let employer_name = employer_name_field.val();
    let contact_phone = contact_phone_field.val();
    let employee_headcount = employee_headcount_field.val();
    let payroll_provider = payroll_provider_field.val();
    let payroll_frequency = payroll_frequency_field.val();
    let street = street_field.val();
    let street2 = street2_field.val();
    let city = city_field.val();
    let state = state_field.val();
    let zip = zip_field.val();
    let can_we_send_email_to_email = [];
    if (!(employer_name.toString().length > 1)) {
      can_we_send_email_to_email.push(employer_name_field.attr('placeholder'));
    }
    if (!(contact_phone.toString().length > 1)) {
      can_we_send_email_to_email.push(contact_phone_field.attr('placeholder'));
    }
    if (!(employee_headcount.toString().length > 1)) {
      can_we_send_email_to_email.push(employee_headcount_field.attr('placeholder'));
    }
    if (!(payroll_provider.toString().length > 1)) {
      can_we_send_email_to_email.push(payroll_provider_field.attr('placeholder'));
    }
    if (!(payroll_frequency.toString().length > 1)) {
      can_we_send_email_to_email.push(payroll_frequency_field.attr('placeholder'));
    }
    if (!(street.toString().length > 1)) {
      can_we_send_email_to_email.push(street_field.attr('placeholder'));
    }
    // if(!(street2.toString().length > 1)){
    //   can_we_send_email_to_email.push(street2_field.attr('placeholder'));
    // }
    if (!(city.toString().length > 1)) {
      can_we_send_email_to_email.push(city_field.attr('placeholder'));
    }
    if (!(state.toString().length > 1)) {
      can_we_send_email_to_email.push(state_field.attr('placeholder'));
    }
    if (!(zip.toString().length > 1)) {
      can_we_send_email_to_email.push(zip_field.attr('placeholder'));
    }
    if (can_we_send_email_to_email.length > 0) {
      let alert_statement = "";
      if (can_we_send_email_to_email.length == 1) {
        alert_statement = `${ can_we_send_email_to_email.slice(-1) } is required!`;
      } else {
        alert_statement = `${ can_we_send_email_to_email.slice(0, can_we_send_email_to_email.length - 1).join(', ') + ", and " + can_we_send_email_to_email.slice(-1) } are required!`;
      }
      alert(alert_statement);
    } else {
      $.ajax({
        url: `/manager/enrollment_requests/send_email_to_eml`,
        type: "POST",
        data: $('input[name!=_method]', form).serialize(),
        success(data) {
          if (data.status == 'success') {
            submit_button.attr('disabled', false);
            submit_button.removeClass('opacity-50');
          }
        }
      });
    alert("Email sent to Eml")
    }
  });

  $(document).on('change', '.payroll_file_format_checkbox[type="checkbox"]', function() {
    let _this_ = this;
    if (_this_.checked) {
      $(_this_).parents('tr.nested-fields').find('td:last(2) input').attr('required', true);
    } else {
      $(_this_).parents('tr.nested-fields').find('td:last(2) input').attr('required', false);
    }
  });

  $(document).on('change', "select#wallets_card_transaction_from_wallet_id", function() {
    $(this).parents('form').find('input#wallets_card_transaction_unallocated_funds_amount:hidden').val($('select#wallets_card_transaction_from_wallet_id option:selected:last').data('amount'));
  });

  $(document).on('change', "select#play_away_deal_activity", function() {
    let _this_ = this;
    let form = $(_this_).parents('form');
    if (_this_.value == "link") {
      form.find("#link_external_link_manager_playaway_deals:last").removeClass("hidden");
      form.find("input#play_away_deal_external_link:last").attr("required", true);
      form.find("input#play_away_deal_external_link:last").attr("disabled", false);
      form.find("#map_manager_playaway_deals:last").addClass("hidden");
    } else {
      form.find("#link_external_link_manager_playaway_deals:last").addClass("hidden");
      form.find("input#play_away_deal_external_link:last").attr("required", false);
      form.find("input#play_away_deal_external_link:last").attr("disabled", true);
      form.find("#map_manager_playaway_deals:last").removeClass("hidden");
    }
  });

  $(document).on('click', 'button.verify_payroll_method', function() {
    let _this_ = this;
    let company_no = "";
    if ($(_this_).parents('form').find('input[id="payroll_method_company_no"][name="payroll_method[company_no]"]').length > 0) {
      company_no = $(_this_).parents('form').find('input[id="payroll_method_company_no"][name="payroll_method[company_no]"]').val();
    } else {
      company_no = $(_this_).parents('form').find('input[id^="company_payroll_methods_attributes_"][id$="_company_no"][name^="company[payroll_methods_attributes]"][name$="[company_no]"]').val();
    }
    $.ajax({
      url: `/employer/payroll_methods/verify_payroll_method`,
      type: "POST",
      data: {
        company_no: company_no,
      },
      success(data) {
        alert(data.message);
      }
    });
  });

  $(document).on("change", 'form#global_employer_contribution_form [name="contribution_schedule[status]"][type="checkbox"]', function() {
    let _this_ = this;
    let contribution_value_block = $(_this_).parents('form').find('div.contribution_value_block');
    contribution_value_block.each(function() {
      if (_this_.checked) {
        contribution_value_block.removeClass('hidden');
        contribution_value_block.find('input:required').attr('required', false);
      } else {
        contribution_value_block.find('input:required').attr('required', false);
        contribution_value_block.addClass('hidden');
      }
    });
  });

  // $(document).on("change", 'form#new_service_request [name="service_request[request_type]"][id="service_request_request_type"]', function() {
  //   let _this_ = this;
  //   $(_this_).parents("#modal-add-new-service-request").find("h4").text(`Add ${ $(_this_).find('option:selected').text() }`);
  // });
  $(document).on("change", 'form#new_service_request [name="service_request[request_type]"][id="service_request_request_type"]', function() {
    let _this_ = this;
    switch($(_this_).find('option:selected').text()) {
      case "Other":
        $(_this_).parents("#modal-add-new-service-request").find("h4").text(`Please describe the details of the integration you would like 401(play) to review?`);
        break;
      default:
        $(_this_).parents("#modal-add-new-service-request").find("h4").text(`Add ${ $(_this_).find('option:selected').text() }`);
    }
  });

  // $(document).on("submit",'form.unmask_masked_fields', function(){
  //   $(this).find('input[id$="_amount"]').each(function(){
  //     if(this.value.indexOf("$") >= 0){
  //       Inputmask.setValue(this,this.value.substring(1));
  //       $(this).val(this.value.substring(1));
  //     }
  //   });
  //   return true;
  // });

  maskCurrencyDecimalFields();
  maskPhoneNumberFields();
  makeSocialSecurityFields();
  maskPercentageFields();

  $(document).on('click', 'svg.password_field_event', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    let parent_div = $(this).parents('div.relative');
    let hidden_svg = parent_div.find('svg:hidden:last');
    hidden_svg.removeClass('hidden');
    hidden_svg.addClass('block');
    $(this).addClass('hidden');
    $(this).removeClass('block');
    if ($(this).hasClass('opened_eye')) {
      let password_field = parent_div.find('input[type="password"]:last');
      password_field.attr('type', 'text');
    } else {
      let text_field = parent_div.find('input[type="text"]:last');
      text_field.attr('type', 'password');
    }
  });

  let mapElement = document.getElementById('map');
  if (!!mapElement) {
    showMap(mapElement);
  }

  $(document).on('click', 'a[href="#new-ajax-modal"][id="playaway_deal_edit_map"]', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    var _check_exist_ = setInterval(function() {
      let mapElement1 = document.getElementById('map_edit');
      if (!!mapElement1) {
        showMap(mapElement1);
        clearInterval(_check_exist_);
      }
    }, 100);
  });

  $(document).on('keyup', 'input#play_away_deal_latitude, input#play_away_deal_longitude, input#new_play_away_deal_latitude, input#new_play_away_deal_longitude', function() {
    let _this_ = $(this);
    let latitude, longitude = "";
    if (_this_.attr('id').indexOf('new_') >= 0) {
      latitude = _this_.parents('form').find('input#new_play_away_deal_latitude').val();
      longitude = _this_.parents('form').find('input#new_play_away_deal_longitude').val();
    } else {
      latitude = _this_.parents('form').find('input#play_away_deal_latitude').val();
      longitude = _this_.parents('form').find('input#play_away_deal_longitude').val();
    }
    var _check_exist_ = setTimeout(function() {
      let mapElement = "";
      mapElement = document.getElementById('map_edit');
      mapElement ||= document.getElementById('map');
      if (!!mapElement) {
        showMap(mapElement, latitude, longitude);
        clearInterval(_check_exist_);
      }
    }, 500);
  });

  $(document).on('click', 'form.trip_cancelled_form button[data-type^="cancelled"]', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    let _this_ = $(this);
    _this_.parents('form.trip_cancelled_form').find('input[id="trip_trip_type"]:hidden').val(_this_.data('type'));
    setTimeout(function() {
      _this_.parents('form.trip_cancelled_form').submit();
    }, 200);
  });

  $('#registration_participant_step1_form, #registration_participant_step4_form').submit(function() {
    let should_submit = true;
    let message = "please read and check all agreements before submit.";
    if ($(this).find('[id$=monthly_estimated_load]').length > 0 && $(this).find('[id$=monthly_estimated_load]').val().length <= 0) {
      alert(`Please select money option and enter amount by click other`);
      should_submit = false;
      return false;
    }
    $(this).find('[required][type="checkbox"]:not(:checked)').each(function() {
      if ($(this).attr('type') == 'checkbox' && !this.checked) {
        alert(`${ message }`);
        should_submit = false;
        return false;
      }
    });
    return should_submit;
  });
  if (document.querySelector('#user_digital_signature_attributes_patriot_act_acceptance')) {
    document.querySelector('#user_digital_signature_attributes_patriot_act_acceptance').value = moment().format('MMMM Do YYYY, h:mm:ss a ZZ');
  }
  if (document.querySelector('#user_digital_signature_attributes_privacy_policy_acceptance')) {
    document.querySelector('#user_digital_signature_attributes_privacy_policy_acceptance').value = moment().format('MMMM Do YYYY, h:mm:ss a ZZ');
  }
  if (document.querySelector('#user_digital_signature_attributes_acceptance')) {
    document.querySelector('#user_digital_signature_attributes_acceptance').value = moment().format('MMMM Do YYYY, h:mm:ss a ZZ');
  }
  if (document.querySelector('#user_digital_signature_attributes_terms_and_conditions_accepted')) {
    document.querySelector('#user_digital_signature_attributes_terms_and_conditions_accepted').value = moment().format('MMMM Do YYYY, h:mm:ss a ZZ');
  }

  if (document.querySelector('#user_digital_signature_attributes_card_holder_agreement')) {
    document.querySelector('#user_digital_signature_attributes_card_holder_agreement').value = moment().format('MMMM Do YYYY, h:mm:ss a ZZ');
  }
  if (document.querySelector('#user_digital_signature_attributes_e_sign_consent_agreement')) {
    document.querySelector('#user_digital_signature_attributes_e_sign_consent_agreement').value = moment().format('MMMM Do YYYY, h:mm:ss a ZZ');
  }
  if (document.querySelector('#user_digital_signature_attributes_pay_me')) {
    document.querySelector('#user_digital_signature_attributes_pay_me').value = moment().format('MMMM Do YYYY, h:mm:ss a ZZ');
  }


  $(document).on('change', '.select_state_name', function() {
    const itself = $(this);
    const form = itself.parents('form');
    const select_country_name = form.find('select.trip_edit_select_country_name');
    if (itself.hasClass('trip_edit_select_state_name')) {
      const edit_trip_step_display_img = form.find('img.edit_trip_step_display_img');
      const submit_button = form.find("button[type='submit']");
      submit_button.text('processing...');
      submit_button.attr('type', 'button');
      $.ajax({
        url: `/place_images/fetch_place_image?country_name=${ select_country_name.val() }&state_name=${ itself.val() }`,
        success(data) {
          edit_trip_step_display_img.attr('src', data.url);
          form.find('input.trip_photo_photo_url[type="hidden"]').val(data.url);
          setTimeout(function() {
            submit_button.text('Save Changes');
            submit_button.attr('type', 'submit');
          }, 500);
        }
      });
    }
  });

  $(document).on('keyup', '.select_city_name', function() {
    const itself = $(this);
    if (itself.val().length > 2) {
      const form = itself.parents('form');
      const select_country_name = form.find('select.trip_edit_select_country_name');
      const select_state_name = form.find('select.trip_edit_select_state_name');
      const edit_trip_step_display_img = form.find('img.edit_trip_step_display_img');
      const submit_button = form.find("button[type='submit']");
      submit_button.text('processing...');
      submit_button.attr('type', 'button');
      $.ajax({
        url: `/place_images/fetch_place_image?country_name=${ select_country_name.val() }&state_name=${ select_state_name.val() }&city_name=${ itself.val() }`,
        success(data) {
          edit_trip_step_display_img.attr('src', data.url);
          form.find('input.trip_photo_photo_url[type="hidden"]').val(data.url);
          setTimeout(function() {
            submit_button.text('Save Changes');
            submit_button.attr('type', 'submit');
          }, 500);
        }
      });
    }
  });

  // $(document).on('change','select#wallets_card_transaction_card_transaction_id',function(e){
  //   const _this_ = $(this);
  //   let amount = $('select#wallets_card_transaction_card_transaction_id option:selected').data('amount');
  //   _this_.closest('form').find('input#wallets_card_transaction_amount').val(amount);
  // });

  $(document).on('click', '.manager_filter', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    const _this_ = $(this);
    const form_search_form = _this_.parents('div.container').find('form.search-form');
    if (form_search_form.hasClass('hidden')) {
      form_search_form.removeClass('hidden');
    } else {
      form_search_form.addClass('hidden');
    }
    const manager_filter_close = _this_.parents('.flex.justify-center').find('svg.manager_filter_close');
    if (manager_filter_close.hasClass('hidden')) {
      manager_filter_close.removeClass('hidden');
    } else {
      manager_filter_close.addClass('hidden');
    }
    const manager_filter_open = _this_.parents('.flex.justify-center').find('svg.manager_filter_open');
    if (manager_filter_open.hasClass('hidden')) {
      manager_filter_open.removeClass('hidden');
    } else {
      manager_filter_open.addClass('hidden');
    }
  });

  $(document).on('change', '.lock_unlock_toggle', function(e) {
    const form = $(this).parents('form');
    const _this_ = form.find('select');
    var newOptions = ["Unlock the Card"];
    if (this.checked) {
      var newOptions = ["Damaged", "Data Breach", "Lost", "Miscellaneous", "Office Error", "PastAccount/ExpirationDate,Stolen", "UnclaimedProperty"];
    }
    $(_this_).empty();
    $.each(newOptions, function(key, value) {
      $(_this_).append($("<option></option>").attr("value", value).text(value));
    });
  });

  $(document).on('keyup', '#user_profile_phone', function(e) {
    $(this).parents('form').find('button.modal-toggle').attr('data-phone_number', this.value);
    $(this).parents('body').find('form[action="/user_profiles/profile_update_verification"] button.generate_code').attr('data-phone_number', this.value);
  });

  $(document).on('keyup', '#company_phone', function(e) {
    $(this).parents('form').find('button.modal-toggle').attr('data-phone_number', this.value);
    $(this).parents('body').find('form[action="/employer/settings/profile_update_verification"] button.generate_code').attr('data-phone_number', this.value);
  });

  $(document).on('keyup', '#user_user_profile_attributes_phone', function(e) {
    $(this).parents('form').find('button.modal-toggle').attr('data-phone_number', this.value);
    $(this).parents('body').find('form[action="/manager/settings/profile_update_verification"] button.generate_code').attr('data-phone_number', this.value);
  });

  $(document).on("ajax:beforeSend", ".confirm_date_before_saving", function(e) {
    if ($(this).find('input:visible').length <= 0) {
      alert('please add some data!');
    }
    return $(this).find('input:visible').length > 0;
  });

  $(document).on('click', '.close_message_box', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    const toggle_message_box = $(this).parents('div.toggle_message_box');
    if (toggle_message_box.hasClass('hidden')) {
      toggle_message_box.removeClass('hidden');
    } else {
      toggle_message_box.addClass('hidden');
    }
  });

  $(document).on('click', '#invites-accept', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    const _this_ = $(this);
    const form = _this_.parents('form');
    form.find('#is_accepted' + _this_.data('id')).val(1);
    form.find('#is_rejected' + _this_.data('id')).val(0);
  });

  $(document).on('click', '#invites-reject', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    const _this_ = $(this);
    const form = _this_.parents('form');
    form.find('#is_accepted' + _this_.data('id')).val(0);
    form.find('#is_rejected' + _this_.data('id')).val(1);
  });

  $(document).on('click', '.status-btn', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    const _this_ = $(this);
    const form = _this_.parents('form');
    form.find('#trip_status' + _this_.data('id')).val(_this_.data('status'));
    form.find('#trip_is_accepted' + _this_.data('id')).val(_this_.data('accepted'));
  });

  $(document).on('click', '.group-status-btn', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    const _this_ = $(this);
    const form = _this_.parents('form');
    form.find('#group_is_accepted' + _this_.data('id')).val(_this_.data('accepted'));
  });

  $(document).on('click', '.unread_reseller_system_notification', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    let currentdate = new Date();
    const _this_ = this;
    var url = `/reseller/system_notifications/${ $(_this_).data('id') }`;
    $.ajax({
      url: url,
      type: "PATCH",
      data: {
        system_notification: { read_at: currentdate.toISOString() }
      },
      success(data) {
        $(_this_).removeClass('bg-blue-50');
      }
    });
  });

  $(document).on('click', '.unread_employer_system_notification', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    let currentdate = new Date();
    const _this_ = this;
    var url = `/employer/system_notifications/${ $(_this_).data('id') }`;
    $.ajax({
      url: url,
      type: "PATCH",
      data: {
        system_notification: { read_at: currentdate.toISOString() }
      },
      success(data) {
        $(_this_).removeClass('bg-blue-50');
      }
    });
  });

  $(document).on('click', '.unread_manager_system_notification', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    let currentdate = new Date();
    const _this_ = this;
    var url = `/manager/system_notifications/${ $(_this_).data('id') }`;
    $.ajax({
      url: url,
      type: "PATCH",
      data: {
        system_notification: { read_at: currentdate.toISOString() }
      },
      success(data) {
        $(_this_).removeClass('bg-blue-50');
      }
    });
  });

  $(document).on('click', '.unread_notification', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    let currentdate = new Date();
    const _this_ = this;
    var url = `/notifications/${ $(_this_).data('id') }`;
    $.ajax({
      url: url,
      type: "PATCH",
      data: {
        notification: { read_at: currentdate.toISOString() }
      },
      success(data) {
        $(_this_).removeClass('bg-blue-50');
      }
    });
  });

  $(document).on('click', '.unread_message', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    const _this_ = this;
    var url = `/messages/${ $(_this_).data('id') }`;
    $.ajax({
      url: url,
      type: "PATCH",
      data: {
        message: { is_read: true }
      },
      success(data) {
        $(_this_).removeClass('bg-blue-50');
      }
    });
  });

  $(document).on('change', 'select#trip_name_and_budget_select', function() {
    $(this).parents('div.my-8.block').find(`a.ajax_modal_btn[data-id="${ this.value }"]:first`).focus();
    var url = `/funds/show_budgets?trip_id=${ this.value }`;
    $.get(url, function(data) {
    });
  });

  $(document).on("click", "button.show_filter", function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    const element_parent = $(this).parent();
    $(this).parents('div.bg-white').find('form.search-form').removeClass('hidden');
    element_parent.removeClass('flex');
    element_parent.addClass('hidden');
  });

  $(document).on("click", "button.hide_filter", function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    $(this).parents('form.search-form').addClass('hidden');
    const show_filter_button = $(this).parents('div.bg-white').find('button.show_filter').parent();
    show_filter_button.addClass('flex');
    show_filter_button.removeClass('hidden');
  });

  $(document).on("click", "#cancel_employee_add_contribution", function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    $(this).parents('.bg-white.py-6.h-500.overflow-scroll.ml-4.right-side').remove();
  });

  document.querySelectorAll('button.monthly-estimated-load-button').forEach((buttonf) => {
    buttonf.addEventListener("click", (e) => {
      // e.preventDefault();
      const parent_div = $(buttonf).parents('div.mb-2');
      const number_button = parent_div.find('input.currency_mask[type="text"]:last');
      parent_div.find('button.monthly-estimated-load-button[type="button"]').removeClass('bg-blue-300');
      $(buttonf).addClass('bg-blue-300');
      if ($(buttonf).data('amount')) {
        number_button.addClass('hidden');
        number_button.val($(buttonf).data('amount'));
      } else {
        number_button.removeClass('hidden');
      }
    });
  });
  $('[id^="pie_all_trip_budget_chart_"]').each(function() {
    const series_data = $(this).data('series');
    if (series_data) {
      let id = $(this).attr('id');
      let options = {};
      if (id == "pie_all_trip_budget_chart_1") {
        options = {
          renderTo: id,
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          width: '280',
          height: '0',
          margin: [-100, 0, 0, 0],
          spacingTop: 0,
          spacingBottom: 0,
          spacingLeft: 0,
          spacingRight: 0
        };
      } else {
        options = {
          renderTo: id,
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          height: '0',
          type: 'pie'
        };
      }
      Highcharts.chart(id, {
        chart: options,
        title: {
          text: ''
        },
        tooltip: {
          formatter: function() {
            // return 'The amount for <b>' + this.point.name + '</b> is <b>$' + `${ this.y.toFixed(2) }` + '</b> and the percentage is <b>' + this.point.percentage.toFixed(2) + '%</b>';
            return `${ this.point.name } = $${ this.y.toFixed(2) }`;
          },
          style: {
            fontSize: '20px'
          }
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            size: '100%',
            dataLabels: {
              enabled: false,
              formatter: function() {
                return '<b>' + this.point.name + '</b>: <b>' + this.point.percentage.toFixed(2) + '%</b> (<b>$' + `${ this.y.toFixed(2) }` + '</b>)';
              }
            }
          }
        },
        colors: chart_colors,
        credits: {
          enabled: false
        },
        series: series_data
      });
    }
  });

  $('[id^="bar_stacked_chart_for_a_trip_"]').each(function() {
    const series_data = $(this).data('series');
    const categories_data = $(this).data('categories');
    if (series_data && categories_data) {
      Highcharts.chart($(this).attr('id'), {
        chart: {
          type: 'bar'
        },
        title: {
          text: ''
        },
        tooltip: {
          formatter: function() {
            return `${ this.series.name } : ${ this.point.percentage.toFixed(2) } % ($ ${ this.y.toFixed(2) })`;
          },
          style: {
            fontSize: '20px'
          }
        },
        xAxis: {
          categories: categories_data
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          }
        },
        legend: false,
        plotOptions: {
          series: {
            stacking: 'normal'
          }
        },
        colors: chart_colors,
        credits: {
          enabled: false
        },
        series: series_data
      });
    }
  });

  $('[id^="bar_stacked_chart_for_a_allocated_fund_trip_"]').each(function() {
    const series_data = $(this).data('series');
    const categories_data = $(this).data('categories');
    if (series_data && categories_data) {
      Highcharts.chart($(this).attr('id'), {
        chart: {
          type: 'bar'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: categories_data
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          }
        },
        legend: {
          reversed: true
        },
        plotOptions: {
          series: {
            stacking: 'normal'
          }
        },
        credits: {
          enabled: false
        },
        series: series_data
      });
    }
  });

  $(".owl-carousel").owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    nav: false,
    // navContainerClass: 'mx-10 absolute inset-0 flex justify-between text-8xl text-white',
    // navClass: [
    // 'focus:outline-none',
    // 'focus:outline-none'
    // ],
  });

  $('.select_trip_transaction_histories').change(function() {
    const _this_ = this;
    const tr = $(_this_).parents('tr');
    const card_transaction_id = $(_this_).attr('data-card-transaction-id');
    const wallet_id = _this_.value;
    $.ajax({
      url: '/transaction_histories/assign_transaction',
      type: "POST",
      data: {
        card_transaction_id: card_transaction_id,
        wallet_id: wallet_id,
      },
      success(data) {
        if (data.success) {
          alert(data.success);
        } else if (data.open_transfer_modal) {
          let modalID = 'new-ajax-modal';
          document.getElementById(modalID).classList.toggle("hidden");
          document.getElementById(modalID + "-backdrop").classList.toggle("hidden");
          document.getElementById(modalID).classList.toggle("flex");
          document.getElementById(modalID + "-backdrop").classList.toggle("flex");
          var url = `/wallets_card_transactions/show_transfer_assign_expense?wallet_id=${ wallet_id }&card_transaction_id=${ card_transaction_id }`;
          $.get(url, function(data) {
          });
        } else if (data.errors) {
          alert(data.errors.join("\n"));
          $(_this_).val('');
        }
      }
    });
  });

  $('.select2').select2();

  $('.add_attendee_select2').select2({
    dropdownParent: $('.add_attendee_form')
  });

  $('.payroll_method_select2').select2({
    dropdownParent: $('.edit_payroll_method')
  });
  weatherWidget();
  itineraryModels();
  cleaveAssignment();
  select_country_and_fetch_states('.select_country_name');

  $('#detect_scroll_down_patriot_act_statement').on('scroll', function() {
    scroll_down_function(this, 'input:checkbox[id$="_patriot_act_acceptance"]:last');
  });

  $('#detect_scroll_down_privacy_policy').on('scroll', function() {
    scroll_down_function(this, 'input:checkbox[id$="_privacy_policy_acceptance"]:last');
  });

  $('#detect_scroll_down_e_sign_consent_agreement').on('scroll', function() {
    scroll_down_function(this, 'input:checkbox[id$="_e_sign_consent_agreement"]:last');
  });

  $('#detect_scroll_down_pay_me').on('scroll', function() {
    scroll_down_function(this, 'input:checkbox[id$="_pay_me"]:last');
  });

  $('#detect_scroll_down_card_holder_agreement').on('scroll', function() {
    scroll_down_function(this, 'input:checkbox[id$="_card_holder_agreement"]:last');
  });

  $('#detect_scroll_down_terms_and_conditions').on('scroll', function() {
    scroll_down_function(this, 'input:checkbox.terms_and_conditions_checkbox[id$="_terms_and_conditions_accepted"]:last');
  });

  // $('.validate_ssn').on('change',function(){
  //   let ssn_input = $(this).parents('form').find('input[id$="_ssn"]');
  //   if(ssn_input.val() != $(this).val()){
  //     alert('')
  //   }
  // });

  $(document).on("change", "#lived_6_months", function() {
    const address2_div = $(this).parents('div.mb-2').next();
    if (this.checked) {
      address2_div.removeClass('hidden');
    } else {
      address2_div.addClass('hidden');
    }
  });

  $('#main_company_data_import_id').change(function(e) {
    $(this).parents('table').find("tbody td input:checkbox").prop("checked", this.checked);
    if (this.checked) {
      $(this).parents('div.container.employer_company_data_imports').find('button#bulk_remove_company_data_imports_id').removeClass('hidden');
    } else {
      $(this).parents('div.container.employer_company_data_imports').find('button#bulk_remove_company_data_imports_id').addClass('hidden');
    }
  });
  $("button#bulk_remove_company_data_imports_id").click(function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    var selectedValue = $(this).data('action');
    const form = $("#employer_company_data_imports_form_id");
    form.find("#action_type").val(selectedValue);
    if (selectedValue == "Delete Selected" || selectedValue == "Delete All") {
      if (confirm('Are you sure you want to delete the Notification?')) {
        form.submit();
      }
    }
  });

  $("input:checkbox[id='company_data_import_ids_']").change(function(e) {
    let company_data_import_ids = $(this).parents('tbody').find("td input:checkbox:checked");
    let bulk_remove_company_data_imports_button = $(this).parents('div.container.employer_company_data_imports').find('button#bulk_remove_company_data_imports_id');
    if (company_data_import_ids.length == 0) {
      bulk_remove_company_data_imports_button.addClass('hidden');
    } else {
      bulk_remove_company_data_imports_button.removeClass('hidden');
    }
  });

  $('#bulk_system_notification_id').change(function(e) {
    $(this).parents('table').find("tbody input:checkbox").prop("checked", this.checked);
  });
  $(".call_bulk_actions_request").click(function(e) {
    var selectedValue = $(this).data('action');
    const form = $("#bulk_actions_system_notification_form");
    $("#action_type").val(selectedValue);
    if (selectedValue == "Make All Read") {
      if (confirm('Are you sure, you want to read all notifications?')) {
        form.submit();
      }
    } else if (selectedValue == "Remove All") {
      if (confirm('Are you sure you want to delete the Notification?')) {
        form.submit();
      }
    }
  });

  const checkboxes = document.querySelectorAll(".notification_check_box");
  checkboxes.forEach(function(checkbox) {
    checkbox.addEventListener("change", function(e) {
      let isAnyCheckboxChecked = false
      checkboxes.forEach(function(checkbox) {
        if (checkbox.checked) {
          isAnyCheckboxChecked = true;
          return;
        }
      });
      if (isAnyCheckboxChecked) {
        document.getElementById('notification_report_id').classList.remove('hidden');
      } else {
        document.getElementById('notification_report_id').classList.add('hidden');
        document.getElementById("main_notification_id").checked = false
      }
    });
  });

  const mainNotificationId = document.querySelector("#main_notification_id");
  if (typeof mainNotificationId !== 'undefined' && mainNotificationId !== null){
    mainNotificationId.addEventListener("change", function(e) {
      const container = this.closest("div.container.mx-auto.bg-dash");
      const checkboxes = container.querySelectorAll("form input[type=checkbox]");
      checkboxes.forEach(function(checkbox) {
        checkbox.checked = mainNotificationId.checked;
      });
      if (mainNotificationId.checked) {
        container.querySelector('a#notification_report_id').classList.remove('hidden');
      } else {
        container.querySelector('a#notification_report_id').classList.add('hidden');
      }
    });
  }

  const notificationReportId = document.querySelector("#notification_report_id");
  if (typeof mainNotificationId !== 'undefined' && mainNotificationId !== null){
    notificationReportId.addEventListener("click", function(e) {
      // e.preventDefault();
      // e.stopPropagation();
      const selectedValue = this.getAttribute('data-action');
      const form = document.querySelector("#notification_report_form");
      form.querySelector("#action_type").value = selectedValue;
      if (selectedValue === "Delete Selected" || selectedValue === "Delete All") {
        if (confirm('Are you sure you want to delete the Notification?')) {
          form.submit();
        }
      }
    });
  }

  $(".clock").each((a, b) => {
    var x = setInterval(function() {
      var mainDiv = $(b);
      var time = mainDiv.data("time");
      var countDownDate = new Date(time).getTime();

      var now = new Date().getTime();
      var distance = countDownDate - now;
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      mainDiv.find(".days").html(days + " days");
      mainDiv.find(".hours").html(hours + " hours");
      mainDiv.find(".minutes").html(minutes + " minutes");
      mainDiv.find(".seconds").html(seconds + " seconds");

      if (distance < 0) {
        clearInterval(x);
        mainDiv.find(".days").html("00 days");
        mainDiv.find(".hours").html("00 hours");
        mainDiv.find(".minutes").html("00 minutes");
        mainDiv.find(".seconds").html("00 seconds");
      }
    }, 1000);
  });


  $(document).on("change", "input[name='trip[travel_date]']", function() {
    var data = moment(new Date(this.value), "DD-MM-YYYY").add(1, 'days');
    var new_date = new Date(data);
    var month = new_date.getMonth() + 1;
    if (month < 10) {
      var month = `0${ month }`;
    }
    var day = new_date.getDate();
    if (day < 10) {
      var day = `0${ day }`;
    }
    $(this).parents('form').find("input[name='trip[trip_end_date]']").attr('min', `${ new_date.getFullYear() }-${ month }-${ day }`);
  });

  $(document).on("change", '#trip_trip_end_date', function() {
    const form = $(this).parents('form');
    let trip_travel_date = form.find('#trip_travel_date');
    let trip_trip_end_date = $(this);
    if ((new Date(trip_travel_date.val())) > (new Date(trip_trip_end_date.val()))) {
      trip_trip_end_date.val('');
      alert('trip_trip_end_date is greater');
    }
  });

  $(document).on("change", "#trip_is_fixed_date", function() {
    event.preventDefault();
    const form = $(this).parents('form');
    const trip_start_and_end_date_container = form.find('div.trip_start_and_end_date_container');
    const trip_months_container = form.find('div.trip_months_container');
    const trip_start_and_end_date_container_data_class = trip_start_and_end_date_container.data('class');
    const trip_months_container_data_class = trip_months_container.data('class');
    trip_months_container.data('class');
    if (this.checked) {
      trip_start_and_end_date_container.removeClass('hidden');
      if (trip_start_and_end_date_container_data_class) {
        trip_start_and_end_date_container.addClass(trip_start_and_end_date_container_data_class);
      }
      trip_months_container.addClass('hidden');
      if (trip_months_container_data_class) {
        trip_months_container.removeClass(trip_months_container_data_class);
      }
      trip_start_and_end_date_container.find('input[type="date"]').attr('required', true);
      trip_months_container.find('select').attr('required', false);
    } else {
      trip_start_and_end_date_container.addClass('hidden');
      if (trip_start_and_end_date_container_data_class) {
        trip_start_and_end_date_container.removeClass(trip_start_and_end_date_container_data_class);
      }
      trip_start_and_end_date_container.find('input[type="date"]').attr('required', false);
      trip_months_container.removeClass('hidden');
      if (trip_months_container_data_class) {
        trip_months_container.addClass(trip_months_container_data_class);
      }
      trip_months_container.find('select').attr('required', true);
    }
  });

  $(document).on('change', '.employees_csv', function(event) {
    let _this_ = this;
    let obj_custom = $(_this_);
    let files = event.target.files;
    let file = files[0];
    $(_this_).parent().find('button').text(file.name);
  });

  $(document).on('change', '#trip_edit_file_browse', function(event) {
    var _this_ = this;
    var obj_custom = $(_this_);
    var files = event.target.files;
    var image = files[0];
    var reader = new FileReader();
    reader.onload = function(file) {
      obj_custom.siblings('img').attr('src', file.target.result);
      if ($(_this_).hasClass('participant_profile_image')) {
        let modalID = 'modal-profile-update-verification';
        document.getElementById(modalID).classList.toggle("hidden");
        document.getElementById(modalID + "-backdrop").classList.toggle("hidden");
        document.getElementById(modalID).classList.toggle("flex");
        document.getElementById(modalID + "-backdrop").classList.toggle("flex");
      }
    };
    reader.readAsDataURL(image);
  });

  $('#company_employer_enrollment_autoupload_logo').change(function() {
    const el = document.querySelector('#company_employer_enrollment_autoupload_logo');
    console.log(el);
    if (el.files && el.files[0].size > 7000000) {
      alert('File exceeds the limit size of 7 MB');
      el.value = ""
      document.querySelector('#employer-image').src = ""
      return;
    }
      var _this_ = this;
      var obj_custom = $(_this_);
      var files = event.target.files;
      var image = files[0];
      var reader = new FileReader();
      reader.onload = function(file) {
        obj_custom.siblings('img').attr('src', file.target.result);
      };
      reader.readAsDataURL(image);
  });

  $(document).on('change', '.display_image', function(event) {
    var obj_custom = $(this);
    var files = event.target.files;
    var image = files[0];
    var reader = new FileReader();
    reader.onload = function(file) {
      obj_custom.siblings('img').attr('src', file.target.result);
    };
    reader.readAsDataURL(image);
  });

  $(document).on('keyup', 'input._trip_invite_email_[type="email"]', function() {
    let _this_ = this;
    let restrict = false;
    if (isEmail(_this_.value)) {
      $('div.add_item_invited_via_email_trip_new_right_list').each(function() {
        if ($.trim(_this_.value) == $.trim($(_this_).find('p.ml-4').data('email'))) {
          restrict = true;
        }
      });
      if ($(_this_).parents('form').find(`[data-email="${ $.trim(_this_.value) }"]`).length > 0) {
        restrict = true;
      }
      if (!restrict) {
        $('div#invite_via_email_trip_invites').find('a.add_fields:last').css('pointer-events', 'auto');
      } else {
        $('div#invite_via_email_trip_invites').find('a.add_fields:last').css('pointer-events', 'none');
      }
    }
  });

  $(document).on("click", "button#delete_invite_via_email", function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    let _this_ = this;
    let select_entry = null;
    $('div.nested-fields.trip_invites_from_list_item').find(`input[type="email"`).each(function() {
      if ($(this).val() == $(_this_).data('email')) {
        select_entry = $(this);
      }
    });
    $(_this_).parents('.add_item_invited_via_email_trip_new_right_list').remove();
    select_entry.parents('.nested-fields.trip_invites_from_list_item').remove();
  });

  $(document).on('cocoon:before-insert', '#wallets_card_transactions_expandable_fields', function(e, insertedItem, originalEvent) {
    maskCurrencyDecimalFields($(insertedItem).find('input.currency_mask[type="text"][id$="_amount"]'));
  });

  $(document).on('cocoon:before-insert', '#trip_budgets_expandable_fields, #trip_expenses_expandable_fields, #trip_creation_budgets_expandable_fields', function(e, insertedItem, originalEvent) {
    maskCurrencyDecimalFields($(insertedItem).find('input.currency_mask[type="text"][id$="_amount"]'));
  });

  $(document).on('click', 'a.new_recurring_contribution_customizable_link', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    var _check_exist_ = setInterval(function() {
      if ($('input.new_recurring_contribution_expandable_amount_field[type=text]').length > 0) {
        maskCurrencyDecimalFields();
        clearInterval(_check_exist_);
      }
    }, 200);
  });

  $(document).on('click', 'a.edit_manager_reseller_customizable_link', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    var _check_exist_ = setInterval(function() {
      if ($('input.edit_manager_reseller_phone_field[type=tel]').length > 0 && $('input.edit_manager_reseller_amount_field[type=text]').length > 0) {
        maskPhoneNumberFields();
        maskCurrencyDecimalFields();
        clearInterval(_check_exist_);
      }
    }, 200);
  });

  $(document).on('click', 'a.ajax_modal_btn.modal-toggle', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    var _check_exist_ = setInterval(function() {

      if ($("input.contact_invite_edit_phone[type='tel']").length > 0) {
        maskPhoneNumberFields();
        clearInterval(_check_exist_);
      }
    }, 200);
  });

  $(document).on('click', 'a.edit_manager_enrolled_company_customizable_link', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    var _check_exist_ = setInterval(function() {
      if ($('input.edit_manager_enrolled_company_phone_field[type=tel]').length > 0) {
        maskPhoneNumberFields();
        $('.input_ein').toArray().forEach((field) => {
          new Cleave(field, {
            blocks: [3, 2, 4],
            delimiter: '-',
          });
        });
        clearInterval(_check_exist_);
      }
    }, 200);
  });

  $(document).on('click', 'a.wallets_card_transactions_customizable_link', function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    var _check_exist_ = setInterval(function() {
      if ($('input.wallets_card_transactions_expandable_amount_field[type=text]').length > 0) {
        maskCurrencyDecimalFields();
        clearInterval(_check_exist_);
      }
    }, 200);
  });

  document.querySelectorAll(".contact-list-checkbox").forEach((elem) => {
    elem.addEventListener("click", (e) => {
      let data_email = e.target.dataset['email'];
      let data_name = e.target.dataset['name'];
      if (data_name && data_email) {
        let objId = `invited-${data_name.replace(/\s+/g, '-')}-${data_email.replace(/(\s+)|@|\./g, '-')}`
        let divObj = document.querySelector(`#${objId}`)
        if(e.target.checked) {
          if(!divObj) {
            divObj = document.createElement('div');
            divObj.id = objId;
            divObj.classList.add('p-4');
            divObj.classList.add('add_item_invited_via_email_trip_new_right_list');
            divObj.innerHTML = `
              <div class="flex">
                <div class="flex-2">
                  <div class="flex">
                    <svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" data-name="Ellipse 132" fill="#d5d5d5" id="Ellipse_132" r="11">
                      </circle>
                    </svg>
                    <p class="ml-4" data-email=${ data_email } >
                      ${ data_name } - ${ data_email }
                    </p>
                    <button type="button" id='delete_invite_via_email' data-name=${ data_name } data-email=${ data_email }>
                      <svg class="ml-4" height="15" viewBox="0 0 19.25 22" width="19.25" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.562,1.375H13.406l-.4-.8A1.031,1.031,0,0,0,12.079,0H7.167a1.019,1.019,0,0,0-.92.571l-.4.8H.687A.687.687,0,0,0,0,2.062V3.437a.687.687,0,0,0,.687.687H18.562a.687.687,0,0,0,.688-.687V2.062A.687.687,0,0,0,18.562,1.375ZM2.286,20.066A2.063,2.063,0,0,0,4.344,22H14.906a2.062,2.062,0,0,0,2.058-1.933L17.875,5.5H1.375Z" data-name="Icon awesome-trash" fill="#c10007" id="Icon_awesome-trash">
                        </path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            `;
            document.querySelector('.invited_via_email_trip_new_right_list').appendChild(divObj);
          }
        } else if(divObj) {
          document.querySelector('.invited_via_email_trip_new_right_list').removeChild(divObj)
        }
      }
    });
  });

  $(document).on('cocoon:before-insert', '#invite_via_email_trip_invites', function(e, insertedItem, originalEvent) {
    $(document).find('.trip_invites_from_list_item:visible').hide();
    $(this).find('a.add_fields:last').css('pointer-events', 'none');
    const form = $(this).parents('form');
    $('.trip_invites_from_list_item').find('input[type="text"][placeholder="Name"]').each(function() {
      let data_email = $(this).siblings('input[type="email"]').val();
      let data_name = this.value;
      if (data_name && data_email) {
        let objId = `ive-${data_name.replace(/\s+/g, '-')}-${data_email.replace(/(\s+)|@|\./g, '-')}`
        if(form.find(`.invited_via_email_trip_new_right_list #${objId}`).length < 1) {
          form.find('.invited_via_email_trip_new_right_list').append(
            `<div class="p-4 add_item_invited_via_email_trip_new_right_list">
                <div class="flex">
                  <div class="flex-2">
                    <div class="flex">
                      <svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="11" cy="11" data-name="Ellipse 132" fill="#d5d5d5" id="Ellipse_132" r="11">
                        </circle>
                      </svg>
                      <p class="ml-4" id=${objId} data-email=${ data_email } >
                        ${ data_name } - ${ data_email }
                      </p>
                      <button type="button" id='delete_invite_via_email' data-name=${ this.value } data-email=${ data_email }>
                        <svg class="ml-4" height="15" viewBox="0 0 19.25 22" width="19.25" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18.562,1.375H13.406l-.4-.8A1.031,1.031,0,0,0,12.079,0H7.167a1.019,1.019,0,0,0-.92.571l-.4.8H.687A.687.687,0,0,0,0,2.062V3.437a.687.687,0,0,0,.687.687H18.562a.687.687,0,0,0,.688-.687V2.062A.687.687,0,0,0,18.562,1.375ZM2.286,20.066A2.063,2.063,0,0,0,4.344,22H14.906a2.062,2.062,0,0,0,2.058-1.933L17.875,5.5H1.375Z" data-name="Icon awesome-trash" fill="#c10007" id="Icon_awesome-trash">
                          </path>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>`
          );
        }
      }
    });
  });

  $('.js-contact-select2').select2({
    width: '100%',
    placeholder: "Select User",
  });

  $("a._new_contact_messages_message_").click(function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    activate_contact_messages(this);
  });
  document.querySelectorAll('a[data-associations="budgets"]').forEach((anchor_element) => {
    anchor_element.addEventListener('click', (e) => {
      // e.preventDefault();
      // e.stopPropagation();
      if (e.target.nextElementSibling) {
        e.target.nextElementSibling.style.display = 'block';
      }
    });
  });
  $(document).on("click", ".delete_budget_btn", function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    $(this).closest('.association_div').find('.delete_budget').val(new Date());
  });
  $(document).on("click", ".new_trip_next", function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    const parent_div = e.target.closest('div.trip_steps');
    const open_children = parent_div.querySelector('div.relative.flex-auto:not(.hidden)');
    if (open_children) {
      if (!open_children.classList.contains('new_trip_step_4')) {
        open_children.classList.add('hidden');
        open_children.nextElementSibling.classList.remove("hidden");
      }
    } else {
      open_children = parent_div.querySelector('.relative.flex-auto.new_trip_step_1');
    }
    if (open_children.classList.contains('new_trip_step_2')) {
      // let block_next = _validate_trip_creation_step_(open_children);
      // if (block_next) {
      //   alert('Please fill out all required fields');
      //   open_children.classList.remove('hidden');
      //   open_children.nextElementSibling.addClass("hidden");
      // } else {
      e.target.parentNode.querySelector('button.new_trip_prev').classList.remove('hidden');
      $(e.target).last()[0].classList.remove('hidden');
      // }
    }
    if (open_children.classList.contains('new_trip_step_1') && open_children.classList.contains('hidden')) {
      let block_next = _validate_trip_creation_step_($(open_children));
      if (block_next) {
        alert('Please fill out all required fields');
        open_children.classList.remove('hidden');
        open_children.nextElementSibling.classList.add("hidden");
      } else {
        e.target.parentNode.querySelector('button.new_trip_prev').classList.remove('hidden');
        $(e.target).last()[0].classList.remove('hidden');
        setTimeout(function() {
          maskCurrencyDecimalFields();
        }, 500);
      }
    }
    if (open_children.classList.contains('new_trip_step_3')) {
      let block_next = _validate_trip_creation_step_($(open_children));
      if (block_next) {
        alert('Please fill out all required fields');
        open_children.classList.remove('hidden');
        open_children.nextElementSibling.classList.add("hidden");
      } else {
        const show_attendances_div = parent_div.querySelector('div.flex.show_attendances_div');
        show_attendances_div.innerHTML = `<p>Invitees: </p>`;
        // document.querySelectorAll('.new_trip_step_3 .checkbox').forEach((elem) => {
        //   if(elem.checked) {
        //     let element = elem.closest('div.p-4').querySelector('.contact-name');
        //     let objId = `invited-${element.dataset.name.replace(/\s+/g, '-')}-${element.dataset.email.replace(/(\s+)|@|\./g, '-')}`

        //     if (show_attendances_div.querySelectorAll(`p.ml-2.w-max[data-id=${ objId }]`).length <= 0) {
        //       $(show_attendances_div).append(`
        //           <div class="mx-2 flex">
        //             <svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg">
        //               <circle cx="11" cy="11" data-name="Ellipse 132" fill="#d5d5d5" id="Ellipse_132" r="11">
        //               </circle>
        //             </svg>
        //             <p class="ml-2 w-max" data-id=${ objId }>
        //               ${ element.dataset.name }
        //             </p>
        //           </div>`);
        //     }
        //   }
        // });
        // const show_invitees_div = parent_div.find('div.flex.show_invitees_div');
        // show_invitees_div.children().remove();
        // show_invitees_div.append(`<p>Invitees: </p>`);
        document.querySelectorAll('div.p-4.add_item_invited_via_email_trip_new_right_list').forEach(function(elem) {
          let data_name = elem.querySelector('button[id="delete_invite_via_email"]').dataset.name;
          let objId = `email-${data_name.replace(/\s+/g, '-')}`
          if (show_attendances_div.querySelectorAll(`p.ml-2.w-max[data-id=${ objId }]`).length <= 0) {
            $(show_attendances_div).append(`
              <div class="mx-2 flex">
                <svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="11" cy="11" data-name="Ellipse 132" fill="#d5d5d5" id="Ellipse_132" r="11">
                  </circle>
                </svg>
                <p class="ml-2 w-max" data-id=${objId}>
                  ${ data_name }
                </p>
              </div>`);
          }
        });

        let sum_budget = 0.0;
        parent_div.querySelectorAll('input.trip_creation_budget_amount').forEach(function(elem) {
          if (elem.value) {
            sum_budget += parseFloat(elem.value.substring(1).replace(/,/g, ''), 10);
          }
        });
        parent_div.querySelector('p.mt-4.show_total_budget_div').textContent = ` $${ sum_budget.toFixed(2) }`;
        parent_div.querySelector('p.show_description_div').textContent = parent_div.querySelector('#trip_description').value;
        parent_div.querySelector('p.show_country_name_div').textContent = parent_div.querySelector('#trip_country_name').value;
        if (parent_div.querySelector('#trip_state_name').value != "") {
          parent_div.querySelector('p.show_state_name_div').textContent = parent_div.querySelector('#trip_state_name').value;
        }
        if (parent_div.querySelector('#trip_city_name').value != "") {
          parent_div.querySelector('p.show_city_name_div').textContent = parent_div.querySelector('#trip_city_name').value;
        }
        if (parent_div.querySelector('#trip_is_fixed_date').checked) {
          parent_div.querySelector('span.show_date_range_div').textContent = `${ moment(new Date(parent_div.querySelector('#trip_travel_date').value), "MMM Do").format("MMM Do") } - ${ moment(new Date(parent_div.querySelector('#trip_trip_end_date').value), "MMM Do").format("MMM Do") }`;
        } else {
          parent_div.querySelector('span.show_date_range_div').textContent = parent_div.querySelector('#trip_status').value;
        }
        parent_div.querySelector('h1.body-text.show_trip_name_div').textContent = parent_div.querySelector('#trip_name').value;

        const form = open_children.closest('form');
        const country_name = form.querySelector('select[id="trip_country_name"]').value;
        const state_name = form.querySelector('select[id="trip_state_name"]').value;
        const city_name = form.querySelector('input[id="trip_city_name"]').value;
        let current_element = $(e.target);
        current_element.textContent = 'Fetching...';
        $.ajax({
          url: `/place_images/fetch_place_image?country_name=${ country_name }&state_name=${ state_name }&city_name=${ city_name }`,
          success(data) {
            // form.querySelector('img.new_trip_step_4_img').getAttribute('src', data.url);
            form.querySelector('img.new_trip_step_4_img').src = data.url
            form.querySelector('input#trip_destination_image_url').value = data.url;
            // form.find('input#trip_edit_file_browse').val(data.url);
            current_element.parent().find('button.new_trip_prev')[0].classList.remove('hidden');
            current_element.last()[0].classList.remove('hidden');
            if (open_children.classList.contains('new_trip_step_3') && open_children.nextElementSibling.classList.contains('new_trip_step_4')) {
              setTimeout(function() {
                current_element.text('Submit');
                current_element.attr('type', 'submit');
              }, 500);
            }
          }
        });
      }
    }
    // else if(open_children.hasClass('new_trip_step_2') && open_children.next().hasClass('new_trip_step_3')){
    //   let current_element = $(this);
    //
    //   setTimeout(function(){
    //     current_element.attr('type','submit');
    //   }, 500);
    // }
  });

  $(document).on("click", ".new_trip_prev", function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    const parent_div = e.target.closest('div.trip_steps');
    const open_children = parent_div.querySelector('div.relative.flex-auto:not(.hidden)');
    open_children.classList.add('hidden');
    open_children.previousElementSibling.classList.remove("hidden");
    if (open_children.classList.contains('new_trip_step_4') && open_children.classList.contains('hidden')) {
      $(this).last().next()[0].classList.remove('hidden');
      $(this).last()[0].classList.remove('hidden');
      let current_element = $(this);
      setTimeout(function() {
        current_element.last().next().text('Next');
        current_element.last().next().attr('type', 'button');
      }, 500);

    }
    if (open_children.previousElementSibling.classList.contains('new_trip_step_1')) {
      $(this).last()[0].classList.add('hidden');
      $(this).last().next()[0].classList.remove('hidden');
    }
  });

  $('#deal_new_file_browse').change(function() {
    const el = document.querySelector('#deal_new_file_browse');
    if (el.files && el.files[0].size > 7000000) {
      alert('File exceeds the limit size of 7 MB');
      el.value = ""
      return;
    }
      var _this_ = this;
      var obj_custom = $(_this_);
      var files = event.target.files;
      var image = files[0];
      var reader = new FileReader();
      reader.onload = function(file) {
        obj_custom.siblings('img').attr('src', file.target.result);
      };
      reader.readAsDataURL(image);
  });

  $(document).on('click', `button[class^='new_trip_get_me_to_']`, function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    const not_hidden_step = $(this).parents('div.relative.flex-auto:not(.hidden)');
    const step_rendered_in = $(this).parents('div#new_trip_step_4_modal_space');
    const form = $(this).parents('form');
    let block_next = false;
    if (not_hidden_step.hasClass('new_trip_step_1')) {
      block_next = _validate_trip_creation_step_(not_hidden_step);
    } else if (not_hidden_step.hasClass('new_trip_step_2')) {
      block_next = _validate_trip_creation_step_(not_hidden_step);
    } else if (not_hidden_step.hasClass('new_trip_step_3')) {
      block_next = _validate_trip_creation_step_(not_hidden_step);
    } else if (not_hidden_step.hasClass('new_trip_step_4')) {
      block_next = _validate_trip_creation_step_(not_hidden_step);
    }
    if (block_next) {
      alert('Please fill out all required fields');
    } else {
      if ($(this).hasClass('new_trip_get_me_to_1')) {
        not_hidden_step.last().addClass('hidden');
        step_rendered_in.find('div.new_trip_step_1').last().removeClass('hidden');
        form.find('button.new_trip_next').removeClass('hidden');
        form.find('button.new_trip_next').text('Next');
        form.find('button.new_trip_next').attr('type', 'button');
        form.find('button.new_trip_prev').addClass('hidden');
      } else if ($(this).hasClass('new_trip_get_me_to_2')) {
        not_hidden_step.last().addClass('hidden');
        step_rendered_in.find('div.new_trip_step_2').last().removeClass('hidden');
        form.find('button.new_trip_next').removeClass('hidden');
        form.find('button.new_trip_prev').removeClass('hidden');
        setTimeout(function() {
          maskCurrencyDecimalFields();
        }, 500);
      } else if ($(this).hasClass('new_trip_get_me_to_3')) {
        not_hidden_step.last().addClass('hidden');
        step_rendered_in.find('div.new_trip_step_3').last().removeClass('hidden');
        form.find('button.new_trip_next').removeClass('hidden');
        form.find('button.new_trip_prev').removeClass('hidden');
      } else if ($(this).hasClass('new_trip_get_me_to_4')) {
        const form = not_hidden_step.parents('form');
        const show_attendances_div = form.find('div.flex.show_attendances_div');
        show_attendances_div.children().remove();
        show_attendances_div.append(`<p>Invitees: </p>`);
        document.querySelectorAll('.new_trip_step_3 .checkbox').forEach((elem) => {
          if(elem.checked) {
            let element = elem.closest('div.p-4').querySelector('.contact-name');
            let objId = `invited-${element.dataset.name.replace(/\s+/g, '-')}-${element.dataset.email.replace(/(\s+)|@|\./g, '-')}`

            if (show_attendances_div.querySelectorAll(`p.ml-2.w-max[data-id=${ objId }]`).length <= 0) {
              $(show_attendances_div).append(`
                  <div class="mx-2 flex">
                    <svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" data-name="Ellipse 132" fill="#d5d5d5" id="Ellipse_132" r="11">
                      </circle>
                    </svg>
                    <p class="ml-2 w-max" data-id=${ objId }>
                      ${ element.dataset.name }
                    </p>
                  </div>`);
            }
          }
        });
        // const show_invitees_div = form.find('div.flex.show_invitees_div');
        // show_invitees_div.children().remove();
        // show_invitees_div.append(`<p>Invitees: </p>`);
        $('div.p-4.add_item_invited_via_email_trip_new_right_list').each(function() {
          let data_name = form.find('button[id="delete_invite_via_email"]').data('name');
          $(show_attendances_div).append(`
              <div class="mx-2 flex">
                <svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="11" cy="11" data-name="Ellipse 132" fill="#d5d5d5" id="Ellipse_132" r="11">
                  </circle>
                </svg>
                <p class="ml-2 w-max" data-id='null'>
                  ${ data_name }
                </p>
              </div>`);
        });
        let sum_budget = 0.0;
        form.find('input.trip_creation_budget_amount').each(function() {
          if (this.value) {
            sum_budget += parseFloat(this.value.substring(1).replace(/,/g, ''), 10);
          }
        });

        form.find('p.mt-4.show_total_budget_div').text(` $${ sum_budget.toFixed(2) }`);
        form.find('p.show_description_div').text(form.find('#trip_description').val());
        form.find('p.show_country_name_div').text(form.find('#trip_country_name').val());
        if (form.find('#trip_state_name').val() != "") {
          form.find('p.show_state_name_div').text(form.find('#trip_state_name').val());
        }
        if (form.find('#trip_city_name').val() != "") {
          form.find('p.show_city_name_div').text(form.find('#trip_city_name').val());
        }
        if (form.find('#trip_is_fixed_date').prop('checked')) {
          form.find('span.show_date_range_div').text(`${ moment(new Date(form.find('#trip_travel_date').val()), "MMM Do").format("MMM Do") } - ${ moment(new Date(form.find('#trip_trip_end_date').val()), "MMM Do").format("MMM Do") }`);
        } else {
          form.find('span.show_date_range_div').text(form.find('#trip_status').val());
        }
        form.find('h1.body-text.show_trip_name_div').text($(this).find('#trip_name').val());
        const country_name = form.find('select[id="trip_country_name"]').val();
        const state_name = form.find('select[id="trip_state_name"]').val();
        const city_name = form.find('input[id="trip_city_name"]').val();
        $.ajax({
          url: `/place_images/fetch_place_image?country_name=${ country_name }&state_name=${ state_name }&city_name=${ city_name }`,
          success(data) {
            form.find('img.new_trip_step_4_img').attr('src', data.url);
            form.find('input#trip_destination_image_url').val(data.url);
            // form.find('input#trip_edit_file_browse').val(data.url);
          }
        });
        not_hidden_step.last().addClass('hidden');
        step_rendered_in.find('div.new_trip_step_4').last().removeClass('hidden');
        form.find('button.new_trip_next').text('Submit');
        form.find('button.new_trip_next').attr('type', 'submit');
        form.find('button.new_trip_prev').removeClass('hidden');
      }
    }
  });
});

function activeTab(element) {
  let siblings = element.parentNode.querySelectorAll("li");
  for (let item of siblings) {
    item.classList.add("hover:bg-indigo-50");
    item.classList.remove("text-indigo-700");
    item.classList.remove("bg-indigo-100");
  }
  element.classList.remove("text-gray-600");
  element.classList.add("text-indigo-700");
  element.classList.add("bg-indigo-100");
}
require("trix");
require("@rails/actiontext");
